import React, { useEffect, useState } from 'react';
import { Container } from './styles';
import { useApp } from '../../context';
import loading from '../../assets/gif/loading_lgpd.gif';

interface LoadingProps {
  shown: boolean;
}

const Loading: React.FC<LoadingProps> = ({ shown }) => {
  const { setLoading } = useApp();
  const [showCancellation, setShowCancellation] = useState(false);

  useEffect(() => {
    setShowCancellation(false);
    const timer = setTimeout(() => {
      setShowCancellation(true);
    }, 10000);
    return () => clearTimeout(timer);
  }, [shown]);

  return (
    <Container shown={shown.toString()}>
      <img src={loading} alt="Legal Control LGPD Loading" />
      <p
        className={`${showCancellation ? 'shown' : ''}`}
        aria-hidden
        onClick={() => setLoading(false)}
      >
        Cancelar
      </p>
    </Container>
  );
};

export default Loading;
